import { useRef, useState } from "react";
import axios from "axios";

function Gst() {
  const rName = useRef();
  const rPrice = useRef();
  const rGstamt = useRef();

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [gstamt, setGstamt] = useState("");
  const [msg, setMsg] = useState("");

  const hName = (event) => setName(event.target.value);
  const hPrice = (event) => setPrice(event.target.value);
  const hGstamt = (event) => setGstamt(event.target.value);

  const cal = (event) => {
    event.preventDefault();

    if (name === "") {
      alert("Please enter product name");
      rName.current.focus();
      return;
    }
    if (price === "") {
      alert("Please enter product base price");
      rPrice.current.focus();
      return;
    }
    if (gstamt === "") {
      alert("Please enter GST %");
      rGstamt.current.focus();
      return;
    }

    axios
      .get("https://gst-app-3oho.onrender.com/cal", { params: { name, price, gstamt } })
      .then((response) => {
        setMsg(response.data.msg);

        window.location.href = "https://gst-app-3oho.onrender.com/download";
      })
      .catch((error) => {
        setMsg("Error: " + error.message);
      });
  };

  return (
    <>
      <center>
        <h1>GST Calculator</h1>
        <form onSubmit={cal}>
          <input type="text" placeholder="Enter product name" ref={rName} onChange={hName}/>
          <br/><br />
          <input type="number" placeholder="Enter product base price" ref={rPrice} onChange={hPrice}/>
          <br/><br/>
          <input
type="number" placeholder="Enter GST %" ref={rGstamt} onChange={hGstamt}/>
          <br/><br/>
          <input type="submit" value="Generate & Download Bill" />
        </form>
        <h2>{msg}</h2>
      </center>
    </>
  );
}

export default Gst;
